import isEqual from 'lodash.isequal';
import { toJS } from 'mobx';

import type {
  BlackbaudRaisersEdgeIntegration,
  IBlackbaudRaisersEdgeIntegrationAttributes,
} from '@feathr/blackbox';

/** The model attributes the tabs stage. Save & Sync tracks and sends only these. */
export const STAGED_ATTRIBUTES = [
  'unsubscribe_sync_preference',
  'downsync_activities',
  'upsync_activities',
  'fundraising',
] as const;

type TStagedAttribute = (typeof STAGED_ATTRIBUTES)[number];

/**
 * The staged attributes whose value differs from the saved one. Server-owned attributes can be
 * dirty too (e.g. after OAuth `authenticate()`), and an edit set back to the saved value is no change.
 */
export function getChangedAttributes(
  integration: BlackbaudRaisersEdgeIntegration,
): TStagedAttribute[] {
  return STAGED_ATTRIBUTES.filter(
    (attribute) =>
      integration.isAttributeDirty(attribute) &&
      !isEqual(toJS(integration.get(attribute)), toJS(integration.shadowAttributes[attribute])),
  );
}

/** The PATCH body for the given attributes, as plain values. */
export function getPatch(
  integration: BlackbaudRaisersEdgeIntegration,
  attributes: readonly TStagedAttribute[],
): Partial<IBlackbaudRaisersEdgeIntegrationAttributes> {
  return Object.fromEntries(
    attributes.map((attribute) => [attribute, toJS(integration.get(attribute))]),
  );
}
